export default __webpack_public_path__ + "static/media/blog-sidebar.3b030458.jpg";